/**
 * The wizard steps and their order – aligned with the Figma Make prototype.
 * Registration (the sign-up form) is its own route, `/onboarding/registration`,
 * not a wizard step: the wizard begins once the user has a session.
 *
 * Sources:
 *  - 1/4 outcome step:         Figma Make Screen1Purpose
 *  - 2/4 digital-setup step:   Figma Make Screen2Setup
 *  - 3/4 priority step:        Figma Make Screen3Priority
 *  - 4/4 recommendation step:  Figma Make Screen4Recommendation
 *  - provisioning + summary:   Figma nodes 1272:10102 / 1272:10073
 */
export type OnboardingStep =
  | 'outcome' // 1/4 — What are you trying to create for your people?
  | 'digital-setup' // 2/4 — Which best describes your digital setup?
  | 'priority' // 3/4 — What matters most to you right now?
  | 'recommendation' // 4/4 — We recommend JAAQ Hosted / Embedded
  | 'hosted-audience' // Hosted 1/2 — Who will use your platform?
  | 'hosted-tier' // Hosted 2/2 — Choose your Hosted tier
  | 'summary' // "Your Hub is being prepared. Here's a summary..."
  | 'provisioning'; // Loader: spinner + "Tailoring to your needs"

export const STEP_ORDER: OnboardingStep[] = [
  'outcome',
  'digital-setup',
  'priority',
  'recommendation',
  'hosted-audience',
  'hosted-tier',
  'provisioning',
  'summary',
];

/** Steps that are only shown on the Hosted path. */
export const HOSTED_ONLY_STEPS: ReadonlySet<OnboardingStep> = new Set([
  'hosted-audience',
  'hosted-tier',
]);
